import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults, validateParameters } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Api\Products\ProductReviewsController::__invoke
* @see Http/Controllers/Api/Products/ProductReviewsController.php:17
* @route '/api/products/reviews/{lipscoreId}/{page}/{rating?}'
*/
const ProductReviewsController = (args: { lipscoreId: string | number, page: string | number, rating?: string | number } | [lipscoreId: string | number, page: string | number, rating: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ProductReviewsController.url(args, options),
    method: 'get',
})

ProductReviewsController.definition = {
    methods: ["get","head"],
    url: '/api/products/reviews/{lipscoreId}/{page}/{rating?}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Api\Products\ProductReviewsController::__invoke
* @see Http/Controllers/Api/Products/ProductReviewsController.php:17
* @route '/api/products/reviews/{lipscoreId}/{page}/{rating?}'
*/
ProductReviewsController.url = (args: { lipscoreId: string | number, page: string | number, rating?: string | number } | [lipscoreId: string | number, page: string | number, rating: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            lipscoreId: args[0],
            page: args[1],
            rating: args[2],
        }
    }

    args = applyUrlDefaults(args)

    validateParameters(args, [
        "rating",
    ])

    const parsedArgs = {
        lipscoreId: args.lipscoreId,
        page: args.page,
        rating: args.rating,
    }

    return ProductReviewsController.definition.url
            .replace('{lipscoreId}', parsedArgs.lipscoreId.toString())
            .replace('{page}', parsedArgs.page.toString())
            .replace('{rating?}', parsedArgs.rating?.toString() ?? '')
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Api\Products\ProductReviewsController::__invoke
* @see Http/Controllers/Api/Products/ProductReviewsController.php:17
* @route '/api/products/reviews/{lipscoreId}/{page}/{rating?}'
*/
ProductReviewsController.get = (args: { lipscoreId: string | number, page: string | number, rating?: string | number } | [lipscoreId: string | number, page: string | number, rating: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: ProductReviewsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Products\ProductReviewsController::__invoke
* @see Http/Controllers/Api/Products/ProductReviewsController.php:17
* @route '/api/products/reviews/{lipscoreId}/{page}/{rating?}'
*/
ProductReviewsController.head = (args: { lipscoreId: string | number, page: string | number, rating?: string | number } | [lipscoreId: string | number, page: string | number, rating: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: ProductReviewsController.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Api\Products\ProductReviewsController::__invoke
* @see Http/Controllers/Api/Products/ProductReviewsController.php:17
* @route '/api/products/reviews/{lipscoreId}/{page}/{rating?}'
*/
const ProductReviewsControllerForm = (args: { lipscoreId: string | number, page: string | number, rating?: string | number } | [lipscoreId: string | number, page: string | number, rating: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductReviewsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Products\ProductReviewsController::__invoke
* @see Http/Controllers/Api/Products/ProductReviewsController.php:17
* @route '/api/products/reviews/{lipscoreId}/{page}/{rating?}'
*/
ProductReviewsControllerForm.get = (args: { lipscoreId: string | number, page: string | number, rating?: string | number } | [lipscoreId: string | number, page: string | number, rating: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductReviewsController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Api\Products\ProductReviewsController::__invoke
* @see Http/Controllers/Api/Products/ProductReviewsController.php:17
* @route '/api/products/reviews/{lipscoreId}/{page}/{rating?}'
*/
ProductReviewsControllerForm.head = (args: { lipscoreId: string | number, page: string | number, rating?: string | number } | [lipscoreId: string | number, page: string | number, rating: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: ProductReviewsController.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

ProductReviewsController.form = ProductReviewsControllerForm

export default ProductReviewsController